import React, { Component } from 'react';
import {
	FormText,
} from 'reactstrap';
import {I18n} from '../../../I18n/components/createCompany';
import './step1.css';
import CompanyTypeSelector from '../../Company/CompanyTypeSelector';

export default class Step1 extends Component {
	constructor(props) {
		super(props);

		this.state = {
			name: props.getStore().name,
			types: props.getStore().types,
			countryCode: props.getStore().countryCode,
			cityGeonameId: props.getStore().cityGeonameId
		};
		this._validateOnDemand = true; // this flag enables onBlur validation as user fills forms

		this.validationCheck = this.validationCheck.bind(this);
		this.isValidated = this.isValidated.bind(this);
	}

	componentDidMount () {
	}

	isValidated() {
		const userInput = this._grabUserInput(); // grab user entered vals
		const validateNewInput = this._validateData(userInput); // run the new input against the validator
		let isDataValid = false;

		// if full validation passes then save to store and pass as valid
		if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === true })) {
			if (
				this.props.getStore().name !== userInput.name ||
				this.props.getStore().types !== userInput.types ||
				this.props.getStore().countryCode !== userInput.countryCode ||
				this.props.getStore().cityGeonameId !== userInput.cityGeonameId
			) { // only update store of something changed
				this.props.updateStore({
					...userInput,
					savedToCloud: false // use this to notify step4 that some changes took place and prompt the user to save again
				});  // Update store here (this is just an example, in reality you will do it via redux or flux)
			}

			isDataValid = true;
		}
		else {
			// if anything fails then update the UI validation state but NOT the UI Data State
			this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)));
		}

		return isDataValid;
	}

	validationCheck() {
		console.log('STEP 1', this.state);
		if (!this._validateOnDemand)
			return;

		const userInput = this._grabUserInput(); // grab user entered vals
		const validateNewInput = this._validateData(userInput); // run the new input against the validator

		this.setState(Object.assign(userInput, validateNewInput, this._validationErrors(validateNewInput)),
			() => {console.log('validate', this.state)});
	}

	_validateData(data) {
		return  {
			nameVal: (data.name !== ""),
			typesVal: (data.types.length !== 0),
			countryVal: (data.countryCode !== ""),
			cityVal: (data.cityGeonameId !== "")
		}
	}

	_validationErrors(val) {
		const errMsgs = {
			nameValMsg: val.nameVal ? '' : `${I18n[this.props.lang].stepOne.nameRequired}`,
			typesValMsg: val.typesVal ? '' : `${I18n[this.props.lang].stepOne.typeRequired}`,
			countryValMsg: val.countryVal ? '' : `${I18n[this.props.lang].stepOne.countryRequired}`,
			cityValMsg: val.cityVal ? '' : `${I18n[this.props.lang].stepOne.cityRequired}`
		};
		return errMsgs;
	}

	_grabUserInput() {
		return {
			name: this.refs.name.value,
			types: this.state.types,
			countryCode: this.refs.country.value,
			cityGeonameId: this.refs.city.value
		};
	}

	onCompanyTypeChange = type => {
		const typeValue = [type.value];
		this.setState({
			types: typeValue
		}, () => {
			console.log('step1 state === ', this.state);
		});
	};

	render() {
		const {lang} = this.props;
		// explicit class assigning based on validation
		let notValidClasses = {};
		if (typeof this.state.nameVal === 'undefined' || this.state.nameVal) {
			notValidClasses.nameCls = 'form-control';
		}
		else {
			notValidClasses.nameCls = 'is-invalid form-control';
			notValidClasses.nameValGrpCls = 'text-danger';
		}
		if (typeof this.state.typesVal === 'undefined' || this.state.typesVal) {
			notValidClasses.typesCls = '';
		}
		else {
			notValidClasses.typesCls = 'is-invalid';
			notValidClasses.typesValGrpCls = 'text-danger';
		}
		if (typeof this.state.countryVal === 'undefined' || this.state.countryVal) {
			notValidClasses.countryCls = 'form-control';
		}
		else {
			notValidClasses.countryCls = 'is-invalid form-control';
			notValidClasses.countryValGrpCls = 'text-danger';
		}
		if (typeof this.state.cityVal === 'undefined' || this.state.cityVal) {
			notValidClasses.cityCls = 'form-control';
		}
		else {
			notValidClasses.cityCls = 'is-invalid form-control';
			notValidClasses.cityValGrpCls = 'text-danger';
		}

		return (
			<div className="step step1 mt-5 company-step">
				<div className="row justify-content-md-center">
					<div className="col col-lg-6">
						<div className="">
							<h4>{I18n[lang].stepOne.dataInput}</h4>
							<form id="Form" className="form-horizontal mt-2">
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">
										{I18n[lang].stepOne.companyName}
									</label>
									<div className="col-sm-9">
										<input
											ref="name"
											autoComplete="off"
											type="text"
											placeholder={I18n[lang].stepOne.companyNamePlaceholder}
											className={notValidClasses.nameCls}
											required
											defaultValue={this.state.name}
											onBlur={this.validationCheck} />
										<FormText className="text-muted">{I18n[lang].stepOne.innerUsage}</FormText>
										<div className={notValidClasses.nameValGrpCls}>{this.state.nameValMsg}</div>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">
										{I18n[lang].stepOne.companyType}
									</label>
									<div className="col-sm-9">
										{/*<select*/}
										{/*	ref="types"*/}
										{/*	autoComplete="off"*/}
										{/*	multiple={true}*/}
										{/*	className={notValidClasses.typesCls}*/}
										{/*	required*/}
										{/*	defaultValue={this.state.types}*/}
										{/*	onBlur={this.validationCheck}>*/}
										{/*	/!*<option value="">{I18n[lang].stepOne.chose}</option>*!/*/}
										{/*	<option value="RETAIL">{I18n[lang].stepOne.companyTraders}</option>*/}
										{/*	<option value="DEVELOP">{I18n[lang].stepOne.companyDev}</option>*/}
										{/*</select>*/}
										<CompanyTypeSelector
											className={notValidClasses.typesCls}
											types={this.state.types}
											lang={lang}
											onCompanyTypeChange={this.onCompanyTypeChange}
											validation={this.validationCheck}
										/>
										<div className={notValidClasses.typesValGrpCls}>{this.state.typesValMsg}</div>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">
										{I18n[lang].stepOne.country}
									</label>
									<div className="col-sm-9">
										<select
											ref="country"
											autoComplete="off"
											className={notValidClasses.countryCls}
											required
											defaultValue={this.state.countryCode}
											onBlur={this.validationCheck}
											//onFocus={this.getGeo}
											onChange={this.props.updateCountry}>
											<option value="">{I18n[lang].stepOne.chose}</option>
											{
												(() => {
													return this.props.countries.map(item => {
														return (
															<option
																key={item.geonameId}
																value={item.countryCode}
															>{item.countryName}</option>
														)
													})
												})()
											}
										</select>
										<FormText className="text-muted">{I18n[lang].stepOne.inFieldCountry}</FormText>
										<div className={notValidClasses.countryValGrpCls}>{this.state.countryValMsg}</div>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">
										{I18n[lang].stepOne.city}
									</label>
									<div className="col-sm-9">
										<select
											ref="city"
											autoComplete="off"
											className={notValidClasses.cityCls}
											required
											defaultValue={this.state.cityGeonameId}
											onBlur={this.validationCheck}>
											<option value="">{I18n[lang].stepOne.chose}</option>
											{
												(() => {
													return this.props.cities.map(item => {
														return (
															<option
																key={item.geonameId}
																value={item.geonameId}
															>{item.name}</option>
														)
													})
												})()
											}
										</select>
										<FormText className="text-muted">{I18n[lang].stepOne.centralOffice}</FormText>
										<div className={notValidClasses.cityValGrpCls}>{this.state.cityValMsg}</div>
									</div>
								</div>
							</form>
						</div>
					</div>

				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/CreateCompany/Step1/Step1.js